// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { eventsManifest } from './events';
import { interviewsManifest } from './interviews';
import { mediaRequestsManifest } from './media-requests';
import { newslettersManifest } from './newsletters';
import { pressReleasesManifest } from './press-releases';
import { socialPostsManifest } from './social-posts';

/** Група модулів «Комунікації» (Communications): 6 модулів. */
export const communicationsGroup: IModuleGroupManifest = {
  key: 'communications',
  category: 'Communications',
  name: { en: 'Communications', uk: 'Комунікації' },
  sort: 10,
  modules: [eventsManifest, interviewsManifest, mediaRequestsManifest, newslettersManifest, pressReleasesManifest, socialPostsManifest],
};
